import { NegotiationBoundaryBase } from '@procureai/schemas';
import {
  NegotiationSettingsWidget as NegotiationSettingsWidgetBase,
  NegotiationSettingsWidgetProps,
} from '@procureai/ui-modules-mui';
import { autocompleteOptionDisabledFactory } from '@procureai/ui-mui';

import { I18nNamespace } from '~/common/types';
import { ModuleHash } from '~/modules/Module.types';

import { useSourcingCaseNegotiationSettingsWidgetBackend } from './SourcingCaseNegotiationSettingsWidget.hooks';

const options: Required<Pick<NegotiationSettingsWidgetProps, 'slotProps' | 'i18n'>> = {
  i18n: {
    ns: I18nNamespace.widgets,
    keyPrefix: 'SourcingCaseNegotiationSettingsWidget',
  },
  slotProps: {
    form: {
      slotProps: {
        quoteMode: {
          omit: true,
        },
        negotiationMode: {
          omit: true,
        },
        initiatedBy: {
          omit: true,
        },
        negotiationBoundaryBase: {
          getOptionDisabled: autocompleteOptionDisabledFactory({
            enabled: [NegotiationBoundaryBase.QUOTED_PRICE, NegotiationBoundaryBase.BASELINE_PRICE],
          }),
        },
      },
    },
  },
};

export const SourcingCaseNegotiationSettingsWidget = () => {
  return (
    <NegotiationSettingsWidgetBase
      useBackend={useSourcingCaseNegotiationSettingsWidgetBackend}
      navigationHash={ModuleHash.SOURCING_CASE_NEGOTIATION_SETTINGS}
      intercomTarget={options.i18n.keyPrefix}
      {...options}
    />
  );
};
